import {push} from 'react-router-redux'
import jjv from 'jjv'
import phonez from '../core/phonez'
import {
    DEFAULT_TICKET_QUERY,
    loadTicketStream,
    updateCorrectLocationReferenceCmd,
    updateEmitCallToCmd,
    updateOpenTicketCmd,
} from './actions'
import {OpenTicketCmd} from './models'
import {DEHYDRATE_KEY} from './hydrate'
import i18n from './i18n'

function criteriaUpdated() {
    var criteria

    return (state, dispatch) => {
        const nextCriteria = state.ticket.criteria

        if (nextCriteria != criteria) {

            if (nextCriteria.status != (criteria && criteria.status) ||
                nextCriteria.intervention != (criteria && criteria.intervention) ||
                nextCriteria.location != (criteria && criteria.location) ||
                nextCriteria.clientCompany != (criteria && criteria.clientCompany) ||
                nextCriteria.agency != (criteria && criteria.agency) ||
                nextCriteria.patrimony != (criteria && criteria.patrimony) ||
                nextCriteria.callPurpose != (criteria && criteria.callPurpose) ||
                nextCriteria.from != (criteria && criteria.from) ||
                nextCriteria.to != (criteria && criteria.to)) {

                const location = state.router.location

                dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, ...nextCriteria})).then(() => {
                    if (['/tickets', '/tickets/dashboard'].indexOf(location.pathname) < 0) {
                        dispatch(push('/tickets'))
                    }
                })
            }
            criteria = nextCriteria
        }
    }
}

function openTicketCmdUpdated() {
    var cmd

    const validator = jjv()
    const addressSchema = OpenTicketCmd.schema.properties.ticket.properties.address

    function computeLocationRef(locationRef) {
        if (locationRef && locationRef.locationReferenceType == 'PatrimonyLocation') return {...locationRef, agencyUid: null}
        if (locationRef && locationRef.locationReferenceType == 'AgencyLocation') return {...locationRef, patrimonyUid: null}
        return {locationReferenceType: 'PatrimonyLocation'}
    }

    function computeCaller(caller, address, locationRef) {
        if (!address && !(locationRef && locationRef.patrimonyUid) && !(locationRef && locationRef.agencyUid)) return {callerType: 'ReferencedContactCaller'}
        if (locationRef && locationRef.agencyUid) return (caller && caller.callerType == 'HumanCaller') && caller || {callerType: 'HumanCaller'}
        if (caller && caller.callerType == 'HumanCaller') return caller
        if (caller && caller.callerType == 'ReferencedContactCaller' && caller.uid) return caller
        return {callerType: 'HumanCaller'}
    }

    return (state, dispatch) => {
        var nextCmd = state.ticket.openTicketCmd

        if (nextCmd != cmd && nextCmd && !nextCmd.skipActor) {

            if (nextCmd && nextCmd.ticket != (cmd && cmd.ticket)
                && nextCmd.ticket && nextCmd.ticket.address != (cmd && cmd.ticket && cmd.ticket.address)) {
                const address = nextCmd.ticket.address
                const callerz = nextCmd.ticket.callerz

                const nextLocationRef = computeLocationRef(null)
                const nextCallerz = computeCaller(null, address, nextLocationRef)

                nextCmd = {ticket: {...nextCmd.ticket, callerz: nextCallerz}, locationRef: nextLocationRef}
                dispatch(updateOpenTicketCmd(nextCmd))
            }

            if (nextCmd && nextCmd.locationRef != (cmd && cmd.locationRef)) {
                const locationRef = nextCmd.locationRef
                const address = nextCmd.ticket && nextCmd.ticket.address
                const callerz = nextCmd.ticket && nextCmd.ticket.callerz

                const nextLocationRef = computeLocationRef(locationRef)
                const isAddressValid = address && !validator.validate(addressSchema, address)
                const patrimony = nextLocationRef && nextLocationRef.patrimonyUid
                const nextAddress = !isAddressValid && (patrimony && [...patrimony.addresses, ...patrimony.complementaryAddresses][0]) || address
                const nextCallerz = computeCaller(callerz, nextAddress, nextLocationRef)

                nextCmd = {ticket: {...nextCmd.ticket, address: nextAddress, callerz: nextCallerz}, locationRef: nextLocationRef}
                dispatch(updateOpenTicketCmd(nextCmd))
            }
            cmd = nextCmd
        }
    }
}

function correctLocationReferenceCmd() {
    var cmd

    const validator = jjv()
    const addressSchema = OpenTicketCmd.schema.properties.ticket.properties.address

    return (state, dispatch) => {
        var nextCmd = state.ticket.correctLocationReferenceCmd

        if (nextCmd != cmd && nextCmd && !nextCmd.skipActor) {

            if (nextCmd && nextCmd.locationRef != (cmd && cmd.locationRef)) {
                const locationRef = nextCmd.locationRef
                const address = nextCmd.ticket && nextCmd.ticket.address

                const isAddressValid = address && !validator.validate(addressSchema, address)
                const patrimony = locationRef && locationRef.patrimonyUid
                const nextAddress = !isAddressValid && (patrimony && [...patrimony.addresses, ...patrimony.complementaryAddresses][0]) || address

                nextCmd = {ticket: {...nextCmd.ticket, address: nextAddress}, locationRef}
                dispatch(updateCorrectLocationReferenceCmd(nextCmd))
            }
            cmd = nextCmd
        }
    }
}

function emitCallToCmdUpdated() {
    var cmd

    return (state, dispatch) => {
        const nextCmd = state.ticket.emitCallToCmd

        if (nextCmd != cmd) {

            if (nextCmd && nextCmd.medium != (cmd && cmd.medium)) {
                const phone = cmd && cmd.medium && phonez(cmd.medium.phone).format() || i18n.phonePlaceholder
                const comment = nextCmd.comment
                const nextPhone = nextCmd.medium && phonez(nextCmd.medium.phone).format() || i18n.phonePlaceholder

                const nextComment = comment && comment.replace(phone, nextPhone)
                dispatch(updateEmitCallToCmd({comment: nextComment}))
            }

            cmd = nextCmd
        }
    }
}

function dehydrateNamespaceUpdated() {
    var namespace

    return (state, dispatch) => {
        const nextNamespace = state.ticket

        if (nextNamespace != namespace) {

            if (nextNamespace.exportXlsxTicketsOption != (namespace && namespace.exportXlsxTicketsOption)
                || nextNamespace.exportPdfTicketsOption != (namespace && namespace.exportPdfTicketsOption)
                || nextNamespace.reportPdfTicketsOption != (namespace && namespace.reportPdfTicketsOption)) {
                localStorage.setItem(DEHYDRATE_KEY, JSON.stringify({
                    ticket: {
                        exportXlsxTicketsOption: nextNamespace.exportXlsxTicketsOption,
                        exportPdfTicketsOption: nextNamespace.exportPdfTicketsOption,
                        reportPdfTicketsOption: nextNamespace.reportPdfTicketsOption
                    }
                }))
            }
            namespace = nextNamespace
        }
    }
}

export default [criteriaUpdated(), openTicketCmdUpdated(), dehydrateNamespaceUpdated(), emitCallToCmdUpdated(), correctLocationReferenceCmd()]


// WEBPACK FOOTER //
// ./lib/ticket/actors.js